import { Input } from '@/components/ui/input';
import { Icon } from '@/lib/icons';
import { cn } from '@/lib/utils';
import type { translations } from '@/translations/translations';
import type { ExcelPhraseFormValue } from './excel-phrase.types';

interface Props {
  copy: typeof translations.fr.admin.excelPhrases;
  value: ExcelPhraseFormValue;
  isSubmitting: boolean;
  onChange: (value: ExcelPhraseFormValue) => void;
  onSubmit: () => void;
}

const fieldClass = 'h-10 border-border/50 bg-background text-sm shadow-sm';

export function ExcelPhraseForm({ copy, value, isSubmitting, onChange, onSubmit }: Props) {
  const setField = (field: keyof ExcelPhraseFormValue, fieldValue: string) => {
    onChange({ ...value, [field]: fieldValue });
  };
  const canSubmit = value.local.trim().length > 0 && value.fr.trim().length > 0;

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
      className="rounded-xl border border-border/50 bg-muted/20 p-4"
    >
      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted-foreground">{copy.addTitle}</p>
      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        <Input value={value.local} onChange={(event) => setField('local', event.target.value)} placeholder={copy.local} aria-label={copy.local} maxLength={1000} className={fieldClass} />
        <Input value={value.fr} onChange={(event) => setField('fr', event.target.value)} placeholder={copy.fr} aria-label={copy.fr} maxLength={1000} className={fieldClass} />
        <Input value={value.domain} onChange={(event) => setField('domain', event.target.value)} placeholder={copy.domain} aria-label={copy.domain} maxLength={255} className={fieldClass} />
        <Input value={value.source} onChange={(event) => setField('source', event.target.value)} placeholder={copy.source} aria-label={copy.source} maxLength={255} className={fieldClass} />
      </div>
      <div className="mt-3 flex justify-end">
        <button type="submit" disabled={!canSubmit || isSubmitting} className="inline-flex h-9 items-center gap-2 rounded-full bg-primary px-5 text-xs font-semibold text-primary-foreground shadow-sm transition-opacity hover:opacity-90 disabled:opacity-40">
          <Icon name={isSubmitting ? 'loader2' : 'plus'} className={cn('h-4 w-4', isSubmitting && 'animate-spin')} />
          {isSubmitting ? copy.adding : copy.add}
        </button>
      </div>
    </form>
  );
}
